import React, { useState } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';
import { Dialog, DialogTitle, DialogBody } from './dialog';
import { Badge } from './badge';
import { ArrowDownTrayIcon, ClockIcon } from '@heroicons/react/24/solid';

const FileHistoryPopover = ({ open, onClose, history = [], currentFile, label }) => {
  const [downloading, setDownloading] = useState(null);

  const handleDownload = async (storagePath, fileName, idx) => {
    if (!storagePath) return;
    setDownloading(idx);
    try {
      const fileRef = ref(storage, storagePath);
      const url = await getDownloadURL(fileRef);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error downloading file:', error);
      alert('Error al abrir el archivo.');
    } finally {
      setDownloading(null);
    }
  };

  const formatDate = (ts) => {
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const allVersions = [];

  // Current version first
  if (currentFile?.fileName) {
    allVersions.push({
      fileName: currentFile.fileName,
      uploadedAt: currentFile.uploadedAt,
      storagePath: currentFile.storagePath,
      isCurrent: true,
    });
  }

  // History versions (newest first)
  if (history?.length > 0) {
    const sorted = [...history].sort((a, b) => {
      const dateA = a.uploadedAt?.toDate ? a.uploadedAt.toDate() : new Date(a.uploadedAt || 0);
      const dateB = b.uploadedAt?.toDate ? b.uploadedAt.toDate() : new Date(b.uploadedAt || 0);
      return dateB - dateA;
    });
    sorted.forEach((h) => allVersions.push({ ...h, isCurrent: false }));
  }

  return (
    <Dialog open={open} onClose={onClose} size="sm">
      <DialogTitle>
        <div className="flex items-center gap-2">
          <ClockIcon className="w-5 h-5 text-zinc-400" />
          Historial — {label}
        </div>
      </DialogTitle>
      <DialogBody>
        {allVersions.length === 0 ? (
          <p className="text-zinc-500 text-sm text-center py-4">No hay versiones registradas.</p>
        ) : (
          <div className="space-y-2">
            {allVersions.map((v, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between gap-2 py-2 px-3 rounded-lg bg-zinc-50"
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-zinc-700 truncate">
                      {v.fileName}
                    </span>
                    {v.isCurrent && (
                      <Badge color="blue">Actual</Badge>
                    )}
                    {!v.isCurrent && (
                      <Badge color="zinc">v{allVersions.length - idx}</Badge>
                    )}
                  </div>
                  <span className="text-xs text-zinc-400">{formatDate(v.uploadedAt)}</span>
                </div>
                {v.storagePath && (
                  <button
                    onClick={() => handleDownload(v.storagePath, v.fileName, idx)}
                    disabled={downloading === idx}
                    className="p-1.5 rounded-lg text-azul-surelia hover:bg-azul-surelia/10 transition-colors disabled:opacity-50"
                    title="Descargar"
                  >
                    <ArrowDownTrayIcon className="w-4 h-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </DialogBody>
    </Dialog>
  );
};

export default FileHistoryPopover;
